const statusTypes = {
	new: 'new',
	create: 'new',
	added: 'new',
	'?': 'new',
	A: 'new',
	delete: 'delete',
	removed: 'delete',
	D: 'delete',
	edit: 'edit',
	modified: 'edit',
	rename: 'edit',
	C: 'edit',
	M: 'edit',
	R: 'edit',
	T: 'edit',
	U: 'edit',
};

export const OperationFileDecorator = file => {
	const status =
		statusTypes[file.status] ||
		statusTypes[file.action] ||
		statusTypes[file.status?.[0]] ||
		statusTypes[file.indexStatus] ||
		statusTypes[file.workTreeStatus];
	if (!status) throw new Error(`Unsupported project operation file status: ${file.status}`);
	return {
		...file,
		status,
		additions: Number(file.insertions ?? file.additions ?? 0),
		deletions: Number(file.deletions ?? 0),
		diff: file.diff,
		language: 'diff',
	};
};

export const OperationFilesDecorator = files => (Array.isArray(files) ? files.map(OperationFileDecorator) : []);

export const OperationCommitFileDecorator = file =>
	OperationFileDecorator({
		...file,
		path: file.path || file.filename || file.name,
		status: file.status || file.action || file.changeType || 'modified',
		insertions: file.insertions ?? file.additions,
		diff: file.diff || file.patch,
	});

export const OperationCommitFilesDecorator = files =>
	Array.isArray(files)
		? files.map(OperationCommitFileDecorator)
		: Object.values(files || {}).map(OperationCommitFileDecorator);

export const OperationCommitDecorator = commit => {
	const sha = commit.sha || commit.id;
	const files = commit.files || commit.changedFiles || commit.fileChanges;

	return {
		...commit,
		id: commit.id || sha,
		sha,
		shortSha: commit.shortSha || sha?.slice(0, 7),
		title: commit.title || commit.message || commit.commit?.message?.split('\n')?.[0],
		createdAt: commit.committedAt || commit.createdAt || commit.commit?.author?.date,
		authorName: commit.authorName || commit.author?.name || commit.commit?.author?.name,
		files: OperationCommitFilesDecorator(files),
	};
};

export const OperationCommitHistoryDecorator = commits =>
	Array.isArray(commits) ? commits.map(OperationCommitDecorator) : [];
